<template>
    <div>
        <breadcrumbs
            :title="'Vrste sudionika'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Vrsta sudionika: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <vrsta-sudionika-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                ></vrsta-sudionika-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaSudionikaForma from "./VrstaSudionikaForma";
export default {
    name: "VrstaSudionikaDetails",
    components: {
        VrstaSudionikaForma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.vrsta_sudionika_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-sudionika',
                    name: 'Vrste sudionika'
                },
                {
                    path: '/postavke/vrste-sudionika/' + this.id,
                    name: 'Vrsta sudionika: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
